import React, { useState, useEffect } from "react"
import { useParams } from "react-router-dom"
import _ from "lodash"
import { ChevronRight } from "lucide-react"
import { useAppCtx, appStore } from "lib/state";
import { queryTools, cn } from "lib/utils";
import { CollectionLoader, Tabset } from "lib/components"



export default function ClientTemplates(){
  const { cid } = useParams()
  const { appState } = useAppCtx()
  const { store, AppStore }:any = appStore()

  const { data:_Templates } = queryTools.resource.parseQueryForApi("template.all", {})
  const { data:_Client } = queryTools.resource.parseQueryForApi("client.findById", { _id: cid })
  const saveMethod = queryTools.resource.save(["client.all"])

  const saveClientConfig = async (newConfig:any) => {
    let clientData = _.cloneDeep(_Client)
    clientData = _.set(clientData, "configs.templates.all.trx_history.rendering.columns", newConfig)
    console.log(clientData)
    saveMethod.mutate({ resource: "client", data: {...clientData, _id: _Client._id} })
  }

  if( !_Client ) return <></>
  return (
    <div className="w-full flex flex-col pt-4">
      <h3 className="w-full text-lg uppercase pb-1 pl-2 mb-4 border-b border-solid border-slate-700">Templates</h3>

      <Tabset 
        className="w-full my-2"
        defaultTabIdx={0} 
        tabs={[
          { id: "assign", label: "Assign Templates" },
          { id: "customize", label: "Customize Templates" }
        ]}
      >

        <div id="assign">
          <p>Assigning a template to a client means that the template can be customized specifically for that client. Other clients can still use the template if you want, but they will have only the default settings.</p> 
      
          <div className="w-full flex justify-start items-stretch gap-3 mt-4 h-[24rem]">
            <div className="w-3/12">
              <CollectionLoader
                title="Available Templates"
                collection={_Templates}
                selectFn={(item:any) => console.log(item)}
                selectProp="_id"
                labelProp="Title"
                className="h-full border border-solid border-slate-700"
                innerClassName="overflow-y-auto scrollbar" 
              />
            </div>
            <div className="w-1/12 h-full flex justify-center items-center">
              <button className="w-8/12 bg-teal-800 rounded-sm px-2 py-2 flex justify-center items-center">
                <ChevronRight className="size-4 stroke-1 stroke-gray-50" />
              </button>
            </div>
          </div>
        </div>
        <div id="customize">
          <p>Customizing a template for a client means that the template can be customized specifically for that client. Other clients can still use the template if you want, but they will have only the default settings.</p> 
          <p>No templates have been assigned to this client yet.</p>
        </div>
      </Tabset>
    </div>
  )
}